export const UPDATE_GROUP_START = 'UPDATE_GROUP_START';
export const UPDATE_GROUP_END = 'UPDATE_GROUP_END';
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS';
export const UPDATE_GROUP_FAILURE = 'UPDATE_GROUP_FAILURE';
export const UPDATE_GROUP_CLEAR = 'UPDATE_GROUP_CLEAR';
